<div class="interactions">
	<div class="likes" [ngClass]="{ userLiked: article.userLiked }" (click)="toggleLike()"><i class="pi pi-heart"></i>{{article.likeCount}}</div>
	<div class="comments" class="{{cssClass}}" [ngClass]="{ userCommented: article.userCommented }" (click)="commentsClicked()"><i class="pi pi-comment"></i>{{article.commentCount}}</div>
</div>	